<template>
  <div class="page">
    <!--Header-->
    <div class="page-header flex-shrink-0 bg-white border-bottom">
      <div class="container-fluid px-md-4 px-3">
        <div class="row no-gutters d-flex justify-content-between">
          <h3 class="mb-0"><i class="fa fa-building"></i>&nbsp;Properties<b-spinner class="ml-2" v-show="isBusy" small
              label="Small Spinner"></b-spinner></h3>
          <div class="bg-black-10 p-1 border rounded border-1 d-flex align-items-center">
            <span class="bg-white rounded px-3 py-1 text-dark shadow-sm">View By Property</span>
            <router-link title="View by policy" to="/insurancepolicies" class="btn btn-link text-dark px-3 py-1"
              v-if="true">
              View By Policy
            </router-link>
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="overflow-auto mx-3 mt-3">
      <b-table id="properties-table" bordered class="mb-5 rg-table" :items="propertyProvider" :fields="fields"
        :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :busy.sync="isBusy">
        <template v-slot:cell(propertyName)="data">
          <div>
            {{ data.item.propertyName}}
          </div>
        </template>
        <template v-slot:cell(allInGoodStanding)="data">
          {{ data.item.allInGoodStanding == true ? 'Yes': 'No' }}
        </template>
        <template v-slot:cell(numberOfPolicies)="data">
          {{ data.item.numberOfPolicies }}
        </template>
        <template v-slot:cell(propertyId)="data">
          <div>
            <router-link title="Edit Policy"
              :to="{ name: 'PropertyInsurancePolicyDetails', params: { id: data.item.propertyId }}"
              class="btn btn-primary">
              <span class="d-md-block d-none">Manage</span>
              <span class="d-md-none d-block"><i class="fa fa-gear"></i></span>
            </router-link>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'PropertyInsurancePolicies',
  data() {
    return {
      isBusy: false,
      sortBy: 'propertyName',
      sortDesc: false,
      //properties: [],
      fields: [
        { key: 'propertyName', label: 'Property Name' },
        { key: 'allInGoodStanding', label: 'All in Good Standing?' },
        { key: 'numberOfPolicies', label: '# of policies' },
        { key: 'propertyId', label: 'Policy', thStyle:'width:50px' },
      ]
    }
  },
  async created (){
    //await this.doGetPropertyInsurancePolicyStats()
  },
  methods: {
    ...mapActions('company', ['getPropertyInsurancePolicyStatsForList']),
    async propertyProvider(ctx) {
      this.isBusy = true
      console.log(
        'property table ctx is: ' +
        JSON.stringify(ctx, null, 2)
      )
      let properties = await this.doGetPropertyInsurancePolicyStats()
      return properties
    },
    async doGetPropertyInsurancePolicyStats() {
      let result = await this.getPropertyInsurancePolicyStatsForList()
      return result.data.propertyInsurancePolicyStats
    }
  }
}
</script>
<style scoped>

</style>
